var mySlider;
var mySliderBanners;
var width = $(window).width();
var baseUrl = ""; //"//localhost";
var monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
var spinnerVisible = false;
